import { useAuth, useRequestUser } from "../core/Auth"
import { useEffect, useState } from "react"

import { LayoutSplashScreen } from "../../../layout/core"
import { useParams } from "react-router-dom"

export const TokenAuth = () => {
    const { token: base64Token } = useParams()
    const { getUserByToken } = useRequestUser()
    const { logout, setUser, saveAuth } = useAuth()
    const [showSplashScreen, setShowSplashScreen] = useState(true)

    useEffect(() => {
        if (!base64Token) return

        const token = atob(base64Token);
        setShowSplashScreen(true)
        getUserByToken(token)
            .then((user) => {
                saveAuth({ authType: "Custom", token })
                setUser(user)
            })
            .catch(() => logout())
            .finally(() => setShowSplashScreen(false))

        // eslint-disable-next-line
    }, [base64Token])

    return showSplashScreen ? <LayoutSplashScreen /> : <></>
}